<template>
    <!-- Inizio repeater -->
    <tr class="TableRow" :class="{SelectedItem : this.isSelected, InStock: (this.inStock), FewPieces: this.fewPieces, OutOfStock: this.outOfStock}"><!-- Altre classi disponibili: InStock, OutOfStock-->
        <td class="ETProductName">
            <div class="Form">
                <div class="FormRow">
                    <div class="FormBoxWide FormCheckBox">
                        <div class="Label">
                            <span>
                                <i>{{this.variant.Descrizione}}</i>
                                <div class="ItemPreview">
                                    <div class="Frame"><i><img :src="this.getUrlImmagineFull(variant.UrlImmagine,true)" alt="" /></i></div>
                                </div>
                            </span>
                        </div>
                        <div class="Field">
                            <input type="checkbox" id="" value="" @click="this.isSelected = !this.isSelected" :checked="this.isSelected" />
                            <label for="" class="checkmark"></label>
                        </div>
                    </div>
                </div>
            </div>
        </td>
        <td class="ETStock">
            <span class="AvailibilityIcon">&nbsp;</span>
        </td>
        <td class="ETProductColor">
            <small>{{ this.risorse["TabVarColore"] }}</small>
            <span>{{ this.variant.DescrizioneColore}}</span>
        </td>
        <td class="ETProductSize">
            <small>{{ this.risorse["TabVarTaglia"] }}</small>
            <span>{{ variant.DescrizioneTaglia}}</span>
        </td>
        <td class="ETProductCode">
            <small>{{ this.risorse["TabVarCodice"] }}</small>
            <span>{{ variant.CodiceArticolo }}</span>
        </td>
        <td class="ETUnitPrice">
            <small>{{ this.risorse["TabVarPrezzoUn"] }}</small>
            <span>
                <div v-if="variant.PrezzoListino < variant.PrezzoAgente">
                    <span><del>{{this.simboloValuta}} {{ this.formatNumber(variant.PrezzoAgente, 2, ',', '.')}}</del><ins>{{this.simboloValuta}} {{this.formatNumber(this.PrezzoArticolo, 2, ',', '.')}}</ins></span>
                    <div v-if="this.HaScontoLogistico">
                        <a href="javascript:void(0)" @click="this.OpenModal()"><img :class="{NotActive: this.qtaMultiplo }" src="/images/DiscountIconYellow.svg" alt="" /></a>
                    </div>
                </div>
                <div v-else>
                    <span><ins>{{this.simboloValuta}} {{this.formatNumber(this.PrezzoArticolo, 2, ',', '.')}}</ins></span>
                    <div>
                        <a href="javascript:void(0)" @click="this.OpenModal()"><img :class="{NotActive: this.qtaMultiplo }" src="/images/DiscountIconYellow.svg" alt="" /></a>
                    </div>
                </div>
            </span>
        </td>
        <td class="ETQuantity">
            <div class="TableQtySettingBox">
                <div class="TableQtyDel">
                    <a href="javascript:void(0)" @click="this.deleteQty()" ><img src="/images/QtyClearIcon.png" srcset="/images/QtyClearIconRetina.png 2x" alt=""/></a>
                </div>
                <div class="Form">
                    <div class="FormRow">
                        <div class="FormBoxWide FormInputText">
                            <div class="Field"><input type="text" v-model="this.qtyRow" @blur="this.CheckQta()"/></div>
                        </div>
                    </div>
                </div>
                <div class="TableQtyHandling">
                    <a href="javascript:void(0)" @click="this.incrQty()"><img src="/images/QtyAddIcon.png" srcset="/images/QtyAddIconRetina.png 2x" alt=""/></a>
                    <a href="javascript:void(0)" @click="this.decrQty()"><img src="/images/QtySubtractIcon.png" srcset="/images/QtySubtractIconRetina.png 2x" alt=""/></a>
                </div>
            </div>
        </td>
        <td>
            <div class="ETProductCode">
                <div>
                    <span>{{this.DtNuoviArrivi}}</span>
                </div>
            </div>
        </td>
        <td class="ETSubtotal">
            <small>{{ this.risorse["TabVarSub"] }}</small>
            <div v-if="!this.qtaMultiplo">
                <span><del>{{ this.simboloValuta }} {{ this.formatNumber(this.getSubTotal(), 2, ',', '.')}}</del></span>
                <span>{{ this.simboloValuta }} {{ this.formatNumber(this.getSubTotalSconto(), 2, ',', '.')}}</span>
            </div>
            <div v-else>
                <span>{{ this.simboloValuta }} {{ this.formatNumber(this.getSubTotalSconto(), 2, ',', '.')}}</span>
            </div>
        </td>
    </tr>

    <ModalScontiLogistici
        v-model="this.showModal" 
        :PezziConfezione="this.variant.PzConf"
        :ScontoLogistico="this.variant.ScontoLogistico"
    />
</template>

<script>
import ModalScontiLogistici from "@/components/modals/ModalScontiLogistici.vue";
import {priceMixin, CalcoloSoglieMixin, imgMixin, valutaMixin, risorseMixin} from "@/mixin.js";
import { getTransitionRawChildren } from "vue";

export default {
    name : "VariantsTableRow",
    data(){
        return {
            isSelected: false,
            qtyRow: 0,
            showModal: false,
            prevQta: 0
        }
    },
    components:{
        ModalScontiLogistici
    },
    props: {
        rowIndex: Number,
        qtyRowExt: Number,
        variant: Object,
        limitOrangeSemaphore: Number,
        isSelectedExt: Boolean,
        isLastRow: Boolean
    },
    mixins: [priceMixin, CalcoloSoglieMixin, imgMixin, valutaMixin, risorseMixin],
    emits:["updateTableRows"],
    computed:{
        DtNuoviArrivi: function(){
            if(this.variant != null && this.variant.DtNuoviArrivi != null){
                let v = this.variant.DtNuoviArrivi.split('T')[0];
                return v ?? "-";
            }else{
                return "-";
            }
        },
        qtaMultiplo: function(){
            return !((!this.variant.PrezzoBloccato) && (this.variant.PzConf > 1) && (this.qtyRow) &&(this.qtyRow % this.variant.PzConf == 0));
        },
        PrezzoArticolo: function(){
            if(!this.qtaMultiplo){
                return this.variant.PrezzoListino - (this.variant.PrezzoListino * this.variant.ScontoLogistico / 100);
            }
            return this.variant.PrezzoListino;
        },
        HaScontoLogistico: function(){
            return this.variant.PzConf != null && this.variant.PzConf != undefined && this.variant.ScontoLogistico != null && this.variant.ScontoLogistico != undefined && this.variant.PzConf > 0 && this.variant.ScontoLogistico > 0 && this.qtyRow > 0;
        },
        AcquistoMultiplo: function(){
            return this.variant?.PzConf != null && this.variant?.PzConf != undefined && this.variant.PzConf > 1;
        },
    },
    methods:{
        incrQty: function(){
            this.prevQta = this.qtyRow;

            if( this.variant?.VenditaSoloMultipli == true && 
                this.variant?.Multipli != null && 
                this.variant?.Multipli != undefined && 
                this.variant.Multipli > 1 
            ){
                this.qtyRow += this.variant.Multipli;

            } /*else if(
                this.variant?.VenditaSoloMultipli == false && 
                this.variant?.Multipli != null && 
                this.variant?.Multipli != undefined && 
                this.variant.Multipli > 1 &&
                this.qtyRow < this.variant.Multipli
            ){
                this.qtyRow = this.variant.Multipli;
            }*/else{
                this.qtyRow++;
            }
        },
        decrQty: function(){
            this.prevQta = this.qtyRow;
            if(this.variant?.VenditaSoloMultipli == true && this.variant?.Multipli != null && this.variant?.Multipli != undefined && this.variant.Multipli > 1){
                this.qtyRow -= this.variant.Multipli;
            } else if(
                this.variant?.Multipli != null && 
                this.variant?.Multipli != undefined && 
                this.variant.Multipli > 1 &&
                this.qtyRow <= this.variant.Multipli && 
                this.variant?.VenditaSoloMultipli == true
            ){
                this.qtyRow = 0;
            }else{
                this.qtyRow--;
            }

            if(this.qtyRow < 0){
                this.qtyRow = 0;
            }
        },
        deleteQty: function(){
            this.qtyRow = 0;
        },
        updateCart: function(){
            let prezzoNetto = this.variant.PrezzoNetto;
            if(!this.qtaMultiplo){
                prezzoNetto = prezzoNetto - (this.variant.PrezzoNetto * (this.variant.ScontoLogistico / 100));
            }
            this.$store.commit('updateRow', {
                    CodiceArticolo: this.variant.CodiceArticolo,
                    Quantita: this.qtyRow,
                    PrezzoNetto: prezzoNetto,
                    PrezzoListino: this.variant.PrezzoAgente,
                    Sconto1: this.variant.Sconto1,
                    Sconto2: this.variant.Sconto2,
                    Sconto3: this.variant.Sconto3,
                    Sconto4: this.variant.Sconto4,
                    Sconto5: this.variant.Sconto5,
                    ValoreSconto1: this.variant.ValoreSconto1,
                    ValoreSconto2: this.variant.ValoreSconto2,
                    ValoreSconto3: this.variant.ValoreSconto3,
                    ValoreSconto4: this.variant.ValoreSconto4,
                    ValoreSconto5: this.variant.ValoreSconto5,
                    Catalogo: this.variant.CodiceMarca,
                    DescrizioneArticolo: this.variant.Descrizione,
                    DescrizioneTaglia: this.variant.DescrizioneTaglia,
                    DescrizioneColore: this.variant.DescrizioneColore,
                    UrlImmagine: this.variant.UrlImmagine,
                    Valuta: this.codiceValuta,
                    PrezzoAgente: this.variant.PrezzoAgente,
                    IsBackorder: 0,
                    VenditaSoloMultipli: this.variant.VenditaSoloMultipli,
                    Multipli: this.variant.Multipli,
                });
        },
        getSubTotal(){
            let totale = this.qtyRow * this.variant?.PrezzoAgente;
            return totale;
        },
        getSubTotalSconto(){
            let totale = this.qtyRow * this.variant.PrezzoNetto;
            let netto = totale;
            if(!this.qtaMultiplo){
                netto = totale - (totale * (this.variant.ScontoLogistico / 100));
            }
            return netto;
        },
        OpenModal: function(){
            this.showModal = !this.showModal;
        },
        CalcolaMultiplo: function(value, multiple) {
            console.log(value, multiple);
            let scaledValue = value / multiple;
            let lowerMultiple = Math.floor(scaledValue) * multiple;
            let upperMultiple = Math.ceil(scaledValue) * multiple;

            if(lowerMultiple == 0){
                return upperMultiple;
            }else{
                return (value - lowerMultiple < upperMultiple - value) ? lowerMultiple : upperMultiple;
            }
            
        },
        CheckQta: function(){
            let input = parseInt(this.qtyRow);
            if(isNaN(input)){
                this.qtyRow = this.variant?.Multipli;
            }else{
                if(input < 0){
                    this.qtyRow = this.CalcolaMultiplo(this.prevQta, this.variant?.Multipli);
                } else {
                    this.qtyRow = input;
                }
                if(
                    this.variant?.VenditaSoloMultipli == true && 
                    this.variant?.Multipli != null && 
                    this.variant?.Multipli != undefined && 
                    this.variant.Multipli > 1
                ){
                    this.qtyRow = this.CalcolaMultiplo(this.qtyRow, this.variant.Multipli);
                    this.prevQta = this.qtyRow;
                }/* else if(
                    this.variant?.VenditaSoloMultipli == false && 
                    this.variant?.Multipli != null && 
                    this.variant?.Multipli != undefined && 
                    this.variant.Multipli > 1 &&
                    this.qtyRow < this.variant.Multipli
                ){
                    this.qtyRow = this.variant.Multipli;
                }*/
            }
        }
    },
    watch: {
        isSelectedExt: function(newValue){
            this.isSelected = newValue;
        },
        qtyRowExt: function(newValue){
            if(newValue > 0 && this.isSelected){
                console.log(newValue, this );
                this.qtyRow = this.CalcolaMultiplo(newValue, this.variant?.Multipli);
                this.updateCart();
                if(this.isLastRow){
                    this.$emit("updateTableRows");
                }
            }
        },
        qtyRow: function(){
            this.updateCart();
        }
    }
}
</script>

<style>
.OutOfStock {
    color: #101820 !important;
}
</style>